export default function Footer() {
    return (
        <>
            <footer id="footer">
                <div className="container-1400">
                    <div className="footer__wrap">
                        <div className="flogo">
                            <img src="../img/logo-wh.png" alt="(주)에이스펙" />
                        </div>

                        <div className="finfo">
                            <p>주식회사 에이스펙</p>

                            <ul>
                                <li><span>대표</span>김진태</li>
                                <li><span>사업자등록번호</span>771-81-01416</li>
                                <li><span>TEL</span><a href="tel:041-352-7736">041-352-7736</a></li>
                                <li><span>FAX</span>041-355-7736</li>
                            </ul>

                            <ul className="faddr">
                                <li><span>주소</span>충청남도 당진시 서해로 6271-12 L동 2층 203호</li>
                                <li>(공장) 충남 당진시 순성면 본리로 38-42, 2동</li>
                            </ul>
                        </div>

                        <div className="fcopy">
                            <p>COPYRIGHT ⓒASPEC ENG. ALL RIGHT RESERVED.</p>
                            <p>Designed by plumdesign</p>
                        </div>
                    </div>
                </div>
            </footer>
        </>
    );
}